export default __webpack_public_path__ + "static/media/ic3.96a10b92.svg";